import type { SVGProps } from 'react'
const SvgSyDashboard = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M3.4 23c-.7 0-1.2-.2-1.7-.7S1 21.2 1 20.6V3.4c0-.7.2-1.2.7-1.7S2.8 1 3.4 1h7.3v22z" />
		<path fillOpacity={0.5} d="M13.2 23V12H23v8.6c0 .7-.2 1.2-.7 1.7s-1.1.7-1.7.7z" />
		<path fillOpacity={0.24} d="M13.2 9.6V1h7.3c.7 0 1.2.2 1.7.7s.7 1.1.7 1.7v6.1h-9.8z" />
	</svg>
)
export default SvgSyDashboard
